// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-units-page {
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding: 16px;
  box-sizing: border-box;
}
.business-units-page .page-title {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.25rem;
  flex: 0 0 auto;
}
.business-units-page .spinner-container {
  display: flex;
  justify-content: center;
  padding: 24px 0;
  flex: 0 0 auto;
}
.business-units-page .two-panel-layout {
  display: grid;
  grid-template-columns: minmax(280px, 580px) 1fr;
  gap: 24px;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
}
.business-units-page .two-panel-layout .left-panel,
.business-units-page .two-panel-layout .right-panel {
  min-height: 0;
}
.business-units-page .two-panel-layout .left-panel {
  border-right: 1px solid var(--p-surface-200, #e0e0e0);
  padding-right: 16px;
  overflow-y: auto;
}
.business-units-page .two-panel-layout .right-panel {
  overflow-y: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/business-units/business-units-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,+CAAA;EACA,SAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AADJ;AAGI;;EAEE,aAAA;AADN;AAII;EACE,qDAAA;EACA,mBAAA;EACA,gBAAA;AAFN;AAKI;EACE,mBAAA;AAHN","sourcesContent":[".business-units-page {\n  display: flex;\n  flex-direction: column;\n  height: 75vh;\n  padding: 16px;\n  box-sizing: border-box;\n\n  .page-title {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 1.25rem;\n    flex: 0 0 auto;\n  }\n\n  .spinner-container {\n    display: flex;\n    justify-content: center;\n    padding: 24px 0;\n    flex: 0 0 auto;\n  }\n\n  .two-panel-layout {\n    display: grid;\n    grid-template-columns: minmax(280px, 580px) 1fr;\n    gap: 24px;\n    align-items: stretch;\n    flex: 1 1 auto;\n    min-height: 0;\n\n    .left-panel,\n    .right-panel {\n      min-height: 0;\n    }\n\n    .left-panel {\n      border-right: 1px solid var(--p-surface-200, #e0e0e0);\n      padding-right: 16px;\n      overflow-y: auto;\n    }\n\n    .right-panel {\n      overflow-y: visible;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
